import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAppStore = defineStore('app', () => {
  // State
  const lang = ref('zh-Hans')
  const publicKey = ref('')
  const user_number = ref('')
  const phone_number = ref('')
  const selectedShare = ref(0)
  const selectedCode = ref(0)
  const selectedCid = ref(0)
  const user_info = ref({})
  const chatAgentId = ref('')
  const chatAgentName = ref('')
  const tradingTimer = ref(null)
  const deletedMsgs = ref([])
  const lastSelectedAccount = ref(null)
  const lastTradingRoute = ref(null)

  // Actions
  function setLang(newLang) {
    lang.value = newLang
  }

  function setPublicKey(key) {
    publicKey.value = key
  }

  function setUserNumber(userNumber) {
    user_number.value = userNumber
  }

  function setUserInfo(info) {
    user_info.value = info
  }

  function setPhoneNumber(number) {
    phone_number.value = number
  }

  function logout() {
    user_info.value = {}
  }

  function setSelectedShare(val) {
    selectedShare.value = val
  }

  function setSelectedCode(val) {
    selectedCode.value = val
  }

  function setSelectedCid(cid) {
    selectedCid.value = cid
  }

  function setAgentId(val) {
    chatAgentId.value = val
  }

  function setAgentName(val) {
    chatAgentName.value = val
  }

  function setTradingTimer(val) {
    tradingTimer.value = val
  }

  function setLastSelectedAccount(account) {
    lastSelectedAccount.value = account
  }

  function setLastTradingRoute(route) {
    lastTradingRoute.value = route
  }

  function setDeletedMsgs(val) {
    deletedMsgs.value.push(val)
  }

  // Persist to localStorage (replacing vuex-along functionality)
  function persistState() {
    const state = {
      lang: lang.value,
      user_number: user_number.value,
      phone_number: phone_number.value,
      selectedShare: selectedShare.value,
      selectedCode: selectedCode.value,
      selectedCid: selectedCid.value,
      chatAgentId: chatAgentId.value,
      chatAgentName: chatAgentName.value,
      lastSelectedAccount: lastSelectedAccount.value,
      lastTradingRoute: lastTradingRoute.value,
    }
    localStorage.setItem('appStore', JSON.stringify(state))
  }

  function restoreState() {
    const saved = localStorage.getItem('appStore')
    if (saved) {
      try {
        const state = JSON.parse(saved)
        lang.value = state.lang || lang.value
        user_number.value = state.user_number || user_number.value
        phone_number.value = state.phone_number || phone_number.value
        selectedShare.value = state.selectedShare || selectedShare.value
        selectedCode.value = state.selectedCode || selectedCode.value
        selectedCid.value = state.selectedCid || selectedCid.value
        chatAgentId.value = state.chatAgentId || chatAgentId.value
        chatAgentName.value = state.chatAgentName || chatAgentName.value
        lastSelectedAccount.value = state.lastSelectedAccount || lastSelectedAccount.value
        lastTradingRoute.value = state.lastTradingRoute || lastTradingRoute.value
      } catch (e) {
        console.error('Error restoring state:', e)
      }
    }
  }

  // Initialize: restore persisted state
  restoreState()

  return {
    // State
    lang,
    publicKey,
    user_number,
    phone_number,
    selectedShare,
    selectedCode,
    selectedCid,
    user_info,
    chatAgentId,
    chatAgentName,
    tradingTimer,
    deletedMsgs,
    lastSelectedAccount,
    lastTradingRoute,
    // Actions
    setLang,
    setPublicKey,
    setUserNumber,
    setUserInfo,
    setPhoneNumber,
    logout,
    setSelectedShare,
    setSelectedCode,
    setSelectedCid,
    setAgentId,
    setAgentName,
    setTradingTimer,
    setLastSelectedAccount,
    setLastTradingRoute,
    setDeletedMsgs,
    persistState,
    restoreState,
  }
})

// Export default for backward compatibility
export default useAppStore

